module.exports = __webpack_public_path__ + "img/product.b5aa7d03.png";